export class Links {
  constructor(
    public step: string,
    public name: string,
    public sub_heading:string,
    public url: string) { }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/request-mgmt-foc/links.ts